import { EXPERIMENTS, EXPERIMENTS_DECISIONS } from 'Services/optimizely/optimizely.consts';
import useSortOrder from 'Utilities/hooks/vehicleList/useSortOrder/useSortOrder';

import { useOptimizelyDecision } from '../useOptimizelyDecision';

interface UseRecommendedSortOrderExperimentation {
	recommendedSortOrderVersion: Nullable<string>;
	shouldIncludeRecommendedSortOrderVersion: boolean;
}

const INVALID_EXPERIMENT_DECISIONS: Array<string | null> = [EXPERIMENTS_DECISIONS.RECOMMENDED_SORT_ORDER.off, null];

export const useRecommendedSortOrderExperimentation = (): UseRecommendedSortOrderExperimentation => {
	const { sort } = useSortOrder();
	const isRecommendedSortOrder = sort === 'recommended';

	const { decision, isEnabled } = useOptimizelyDecision({
		attributes: {
			isRecommendedSortOrderActive: isRecommendedSortOrder,
		},
		experimentId: EXPERIMENTS.RECOMMENDED_SORT_ORDER,
	});

	const isValidDecision = Boolean(decision && isEnabled && !INVALID_EXPERIMENT_DECISIONS.includes(decision));

	return {
		recommendedSortOrderVersion: decision,
		shouldIncludeRecommendedSortOrderVersion: isValidDecision,
	};
};
